import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfeContratanteService {
  constructor() {
    this.urlBase = "/faturamento/mdfe-contratante";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default MdfeContratanteService;
